var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level"},[_c('GG'),_c('portal-target',{key:"-1:0",staticClass:"level__gg",attrs:{"name":"-1:0"}}),_vm._l((_vm.level.towers),function(tower,index){return _c('Tower',{key:index,attrs:{"tower":tower,"towerId":index}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }